var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSphereSurface20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 17",
    d: "M18.8889 9.99997C18.8889 14.9092 14.9092 18.8889 10 18.8889C5.09084 18.8889 1.11115 14.9092 1.11115 9.99997C1.11115 5.09078 5.09084 1.11108 10 1.11108C14.9092 1.11108 18.8889 5.09078 18.8889 9.99997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 17 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 18.8889C14.9092 18.8889 18.8889 14.9092 18.8889 10C18.8889 5.0908 14.9092 1.11111 10 1.11111C5.0908 1.11111 1.11111 5.0908 1.11111 10C1.11111 14.9092 5.0908 18.8889 10 18.8889Z",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 37",
    d: "M16.6668 11.4815C17.5626 9.09269 18.3334 6.29632 16.6668 4.0741C17.7779 5.55558 18.889 7.03706 18.889 10C18.889 17.4074 12.7779 18.8889 10.0001 18.8889C7.77788 18.8889 5.55566 18.1482 3.33344 15.9259C7.77788 20.3704 15.5557 14.4445 16.6668 11.4815Z",
    fill: "#222627"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphereSurface20);
export default __webpack_public_path__ + "static/media/sphere_surface_20.784902c69960bd9c1650bf92fd37f410.svg";
export { ForwardRef as ReactComponent };